const ORANGE = "#FF9015";

export function getSampleColor(shift) {
  if (shift.color) return shift.color;
  if (shift.type === "R") return "#9e9e9e";
  return ORANGE;
}

export function getSampleLabel(shift, dynamicLeaves) {
  if (shift.task) return shift.task;
  if (shift.description) return shift.description;
  if (dynamicLeaves && dynamicLeaves[shift.type]) return dynamicLeaves[shift.type].description;
  if (shift.label) return shift.label;
  return shift.type || "?";
}

export function formatMinutes(minutes) {
  if (minutes == null) return "";
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${h < 10 ? "0" : ""}${h}:${m < 10 ? "0" : ""}${m}`;
}
